import UserLogList from './UserLogList'

const userlogs = {
  list: UserLogList,
}

export default userlogs
